/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SpellsRouteImport } from './routes/spells'
import { Route as LaboratoryRouteImport } from './routes/laboratory'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as R404RouteImport } from './routes/404'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GrimoireIndexRouteImport } from './routes/grimoire/index'
import { Route as GrimoireProjectIdRouteImport } from './routes/grimoire/$projectId'
import { Route as AdminEditorIndexRouteImport } from './routes/admin/editor/index'
import { Route as AdminEditorPageIdRouteImport } from './routes/admin/editor/$pageId'

const SpellsRoute = SpellsRouteImport.update({
  id: '/spells',
  path: '/spells',
  getParentRoute: () => rootRouteImport,
} as any)
const LaboratoryRoute = LaboratoryRouteImport.update({
  id: '/laboratory',
  path: '/laboratory',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const GrimoireIndexRoute = GrimoireIndexRouteImport.update({
  id: '/grimoire/',
  path: '/grimoire/',
  getParentRoute: () => rootRouteImport,
} as any)
const GrimoireProjectIdRoute = GrimoireProjectIdRouteImport.update({
  id: '/grimoire/$projectId',
  path: '/grimoire/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEditorIndexRoute = AdminEditorIndexRouteImport.update({
  id: '/admin/editor/',
  path: '/admin/editor/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEditorPageIdRoute = AdminEditorPageIdRouteImport.update({
  id: '/admin/editor/$pageId',
  path: '/admin/editor/$pageId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/contact': typeof ContactRoute
  '/laboratory': typeof LaboratoryRoute
  '/spells': typeof SpellsRoute
  '/grimoire/$projectId': typeof GrimoireProjectIdRoute
  '/grimoire/': typeof GrimoireIndexRoute
  '/admin/editor/$pageId': typeof AdminEditorPageIdRoute
  '/admin/editor/': typeof AdminEditorIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/contact': typeof ContactRoute
  '/laboratory': typeof LaboratoryRoute
  '/spells': typeof SpellsRoute
  '/grimoire/$projectId': typeof GrimoireProjectIdRoute
  '/grimoire': typeof GrimoireIndexRoute
  '/admin/editor/$pageId': typeof AdminEditorPageIdRoute
  '/admin/editor': typeof AdminEditorIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/contact': typeof ContactRoute
  '/laboratory': typeof LaboratoryRoute
  '/spells': typeof SpellsRoute
  '/grimoire/$projectId': typeof GrimoireProjectIdRoute
  '/grimoire/': typeof GrimoireIndexRoute
  '/admin/editor/$pageId': typeof AdminEditorPageIdRoute
  '/admin/editor/': typeof AdminEditorIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/contact'
    | '/laboratory'
    | '/spells'
    | '/grimoire/$projectId'
    | '/grimoire/'
    | '/admin/editor/$pageId'
    | '/admin/editor/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/contact'
    | '/laboratory'
    | '/spells'
    | '/grimoire/$projectId'
    | '/grimoire'
    | '/admin/editor/$pageId'
    | '/admin/editor'
  id:
    | '__root__'
    | '/'
    | '/404'
    | '/contact'
    | '/laboratory'
    | '/spells'
    | '/grimoire/$projectId'
    | '/grimoire/'
    | '/admin/editor/$pageId'
    | '/admin/editor/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  ContactRoute: typeof ContactRoute
  LaboratoryRoute: typeof LaboratoryRoute
  SpellsRoute: typeof SpellsRoute
  GrimoireProjectIdRoute: typeof GrimoireProjectIdRoute
  GrimoireIndexRoute: typeof GrimoireIndexRoute
  AdminEditorPageIdRoute: typeof AdminEditorPageIdRoute
  AdminEditorIndexRoute: typeof AdminEditorIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/spells': {
      id: '/spells'
      path: '/spells'
      fullPath: '/spells'
      preLoaderRoute: typeof SpellsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/laboratory': {
      id: '/laboratory'
      path: '/laboratory'
      fullPath: '/laboratory'
      preLoaderRoute: typeof LaboratoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grimoire/': {
      id: '/grimoire/'
      path: '/grimoire'
      fullPath: '/grimoire/'
      preLoaderRoute: typeof GrimoireIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grimoire/$projectId': {
      id: '/grimoire/$projectId'
      path: '/grimoire/$projectId'
      fullPath: '/grimoire/$projectId'
      preLoaderRoute: typeof GrimoireProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/editor/': {
      id: '/admin/editor/'
      path: '/admin/editor'
      fullPath: '/admin/editor/'
      preLoaderRoute: typeof AdminEditorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/editor/$pageId': {
      id: '/admin/editor/$pageId'
      path: '/admin/editor/$pageId'
      fullPath: '/admin/editor/$pageId'
      preLoaderRoute: typeof AdminEditorPageIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  ContactRoute: ContactRoute,
  LaboratoryRoute: LaboratoryRoute,
  SpellsRoute: SpellsRoute,
  GrimoireProjectIdRoute: GrimoireProjectIdRoute,
  GrimoireIndexRoute: GrimoireIndexRoute,
  AdminEditorPageIdRoute: AdminEditorPageIdRoute,
  AdminEditorIndexRoute: AdminEditorIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
